import React from "react";
import {
	SelectWithLabel,
	BaseSelectWithLabelProps,
	SelectOption,
} from "../InputWithLabel/SelectWithLabel";
import { useFormikFieldState } from "./useFormikField";
import { useCommonLookup } from "newui/store/tanstack-base";

interface DisciplineOption {
	id: number;
	name: string;
}

interface DisciplineSelectProps
	extends Omit<BaseSelectWithLabelProps, "options" | "isLoading"> {
	isLoading?: boolean;
	options: DisciplineOption[];
}

export const DisciplineSelect: React.FC<DisciplineSelectProps> = ({
	label = "Disciplines",
	placeholder = "Select disciplines",
	options,
	value: valueProp,
	hasError: hasErrorProp,
	errorText: errorTextProp,
	onChange: onChangeProp,
	name,
	isLoading,
	...rest
}) => {
	const formik = useFormikFieldState(name);

	const selectOptions: SelectOption[] = options.map((d) => ({
		value: d.id,
		label: d.name,
	}));

	const handleChange = (selected: SelectOption | SelectOption[] | null) => {
		formik.markTouched();
		onChangeProp?.(selected);
	};

	return (
		<SelectWithLabel
			options={selectOptions}
			isMulti
			label={label}
			placeholder={placeholder}
			value={valueProp}
			name={name}
			hasError={hasErrorProp || formik.hasError}
			errorText={errorTextProp || formik.errorText}
			onChange={handleChange}
			isLoading={isLoading}
			{...rest}
		/>
	);
};
